import UnderlineTabNav from '@/components/UnderlineTabNav'
import { useDistributionModeStore } from '@/store/distributionModeStore'
import { useMonthCloseNavStore } from '@/store/monthCloseNavStore'

export default function DistributionModeToggle({ className = '' }: { className?: string }) {
  const mode = useDistributionModeStore((s) => s.mode)
  const setMode = useDistributionModeStore((s) => s.setMode)
  const incomeAllocationCount = useMonthCloseNavStore((s) => s.incomeAllocationCount)
  const showIncomeAllocationDot = incomeAllocationCount > 0
  const incomeAllocationDotLabel =
    incomeAllocationCount === 1
      ? '1 incomplete Income allocation month'
      : `${incomeAllocationCount} incomplete Income allocation months`

  return (
    <UnderlineTabNav
      className={className}
      ariaLabel="Distribution mode"
      tabs={[
        { id: 'cash', label: 'Cash distributions' },
        {
          id: 'income',
          label: 'Income allocation',
          badge: showIncomeAllocationDot ? (
            <span
              className="inline-block h-1.5 w-1.5 shrink-0 rounded-full bg-amber-500"
              title={incomeAllocationDotLabel}
              aria-label={incomeAllocationDotLabel}
            />
          ) : undefined,
        },
      ]}
      activeId={mode}
      onChange={(id) => setMode(id as 'cash' | 'income')}
    />
  )
}
